import Phaser from "phaser";

import { computeViewportInsets } from "../lib/viewport-insets.js";
import { isVisualViewportBoundsSynced } from "../lib/visual-viewport-bounds.js";

import { HUD_BOTTOM_RESERVE_PX } from "./hud-layout.js";

export const INTERACT_HINT_BOTTOM_GAP_PX = 14;
export const INTERACT_HINT_HORIZONTAL_PAD_PX = 24;

/** Bottom-center interact hint with safe-area insets and word wrap on narrow screens. */
export function layoutInteractHint(
  hint: Phaser.GameObjects.Text,
  width: number,
  height: number
): void {
  const insets = computeViewportInsets({
    vw: width,
    innerHeight: typeof window !== "undefined" ? window.innerHeight : height,
    visualViewportHeight:
      typeof window !== "undefined" ? window.visualViewport?.height : undefined,
    visualViewportOffsetTop:
      typeof window !== "undefined" ? window.visualViewport?.offsetTop : undefined,
    boundsSynced: isVisualViewportBoundsSynced(),
  });
  const bottomPad =
    HUD_BOTTOM_RESERVE_PX + insets.bottom + INTERACT_HINT_BOTTOM_GAP_PX;
  const maxWrap = Math.max(
    120,
    width - insets.left - insets.right - INTERACT_HINT_HORIZONTAL_PAD_PX * 2
  );
  hint.setWordWrapWidth(maxWrap);
  hint.setAlign("center");
  hint.setOrigin(0.5, 1);
  hint.setPosition(width / 2, height - bottomPad);
}
